/**
 * eslint-disable jsx-a11y/anchor-is-valid
 *
 * @format
 */

/**
 * eslint-disable jsx-a11y/anchor-is-valid
 *
 * @format
 */

/** @format */

import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useGetCohortsQuery } from "store/services/adminAPI";
import { capitalize, ProgramOptions } from "utils/strings";
import { FadeLoader } from "react-spinners";
import { isAfter, isBefore, isSameDay, addDays } from "date-fns";
import dayjs from "dayjs";
import { Col } from "react-bootstrap";
import { Style } from "utils/select";
import Select from "react-select";
import { years, months, Path } from "utils/constant.data";
import { useNavigate } from "react-router-dom";
import FilterModal from "./helpers/FilterModal";

const AttendanceHeader = ({
  selectedProgram,
  setProgram,
  schedule,
  setSchedule,
  selectedCohort,
  setCohorts,
  setFilter,
  setSelected,
  isLoading,
  handleInputChange,
  search,
  setSearched,
  searched,
  setSearch,
  refetchFellows,

  filterData,
  setShowFilter,
  setModalFilter,
  setFiltered
}) => {
  const [skip, setSkip] = useState(false);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [show, setShow] = useState(false);
  const [filteredSchedules, setFilteredSchedules] = useState([]);
  const navigate = useNavigate();

  const {
    data: cohorts,
    isLoading: loadingCohorts,
    isFetching: fetchingCohorts,
    refetch,
  } = useGetCohortsQuery(`program=${selectedProgram?.value}`, {
    skip: skip,
  });

  const CohortOptions =
    cohorts?.data?.cohorts?.length > 0
      ? cohorts?.data?.cohorts?.map((cohort) => ({
          value: cohort?.id,
          label: `Cohort ${cohort?.rank}`,
        }))
      : [];

  const allCohorts = useMemo(() => cohorts?.data?.cohorts ?? [], [cohorts]);

  const loadOriginalSchedules = useCallback(() => {
    if (allCohorts) {
      const specificCohort = allCohorts?.filter(
        (_cohort) => _cohort?.id === selectedCohort?.value
      );
      if (specificCohort?.length > 0) {
        const schedules = specificCohort[0]?.schedules;
        setFilteredSchedules(schedules);
      }
    }
  }, [allCohorts, selectedCohort]);

  useEffect(() => {
    loadOriginalSchedules();
  }, [loadOriginalSchedules]);

  const filterCohortsByMonthAndYear = (_cohorts, month, year) => {
    const chosenCohort = _cohorts?.filter(
      (_cohort) => _cohort?.id === selectedCohort?.value
    );
    const chosenSchedules = chosenCohort ? chosenCohort[0]?.schedules : [];

    return chosenSchedules?.filter((schedule) => {
      const startDate = schedule.start_date.split("-");
      const endDate = schedule.end_date.split("-");

      const monthMatches = month
        ? Number(startDate[1]) === Number(month) ||
          Number(endDate[1]) === Number(month)
        : true;

      const yearMatches = year
        ? Number(startDate[0]) === Number(year) ||
          Number(endDate[0]) === Number(year)
        : true;

      return monthMatches && yearMatches;
    });
  };

  return (
    <div className="mb-4">
      <div className="row g-3 mb-4 justify-content-between ">
        <div
          className="d-flex align-items-center w-85"
          style={{
            width: "85%",
          }}
        >
          <div className=" max-content me-2">
            <div className="dropdown">
              <button
                className="btn btn-outline-light  text-start d-flex justify-content-between align-items-center"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>Choose Program </span>
                {selectedProgram && <p>{capitalize(selectedProgram?.label)}</p>}
                <i className="bi bi-chevron-down"></i>
              </button>
              <ul className="dropdown-menu w-100">
                {ProgramOptions?.map((option) => (
                  <li
                    key={option.value}
                    onClick={() => {
                      setProgram(option);
                      setSkip(false);
                      refetch();
                    }}
                  >
                    <p className="dropdown-item mb-0 cursor-pointer">
                      {option.label}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="max-content  me-2">
            {loadingCohorts || fetchingCohorts ? (
              <div className="d-flex h-100 justify-content-between align-items-center">
                <p className="mb-0 me-4">Fetching Cohorts....</p>
                <FadeLoader color="#36d7b7" />
              </div>
            ) : (
              CohortOptions?.length > 0 && (
                <div className="dropdown">
                  <button
                    className="btn btn-outline-light text-start d-flex justify-content-between align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>Choose Cohort </span>
                    {selectedCohort ? (
                      <p>{capitalize(selectedCohort?.label)}</p>
                    ) : (
                      <p>Select Cohort</p>
                    )}
                    <i className="bi bi-chevron-down"></i>
                  </button>
                  <ul className="dropdown-menu date-list w-100">
                    {CohortOptions?.length > 0 ? (
                      CohortOptions?.map((option) => (
                        <li
                          key={option.value}
                          onClick={() => {
                            setCohorts(option);
                            setSchedule(null);
                          }}
                        >
                          <p className="dropdown-item mb-0 cursor-pointer">
                            {option.label}
                          </p>
                        </li>
                      ))
                    ) : (
                      <p className="dropdown-item mb-0 cursor-pointer">
                        No cohort data available
                      </p>
                    )}
                  </ul>
                </div>
              )
            )}
          </div>

          {selectedProgram && selectedCohort && (
            <div className="max-content">
              <div className="dropdown">
                <button
                  className="btn btn-outline-light text-start d-flex justify-content-between align-items-center"
                  type="button"
                  onClick={() => setShow(!show)}
                >
                  <span>Choose Time Period</span>
                  {schedule ? (
                    <p>
                      {dayjs(schedule?.start_date).format("MMMM D, YYYY")}
                      {" - "}
                      {dayjs(schedule?.end_date).format("MMMM D, YYYY")}
                    </p>
                  ) : (
                    <p>Select Time Period</p>
                  )}
                  <i className="bi bi-chevron-down"></i>
                </button>
                <ul
                  className={`dropdown-menu ${
                    show ? "show" : ""
                  } w-100 time-period`}
                >
                  <Col md={12}>
                    {allCohorts?.length > 0 && (
                      <div className="d-flex justify-content-between align-items-center">
                        <Col md={5}>
                          <p className="p-1 m-0">Filter with Month</p>
                          <div className="form-group mb-3">
                            <Select
                              value={month}
                              onChange={(e) => {
                                const newSchedules =
                                  filterCohortsByMonthAndYear(
                                    allCohorts,
                                    e?.value,
                                    year?.value ?? null
                                  );
                                setMonth(e);
                                setFilteredSchedules(newSchedules);
                              }}
                              options={months}
                              styles={Style}
                              placeholder="Month"
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <p className="p-1 m-0">Filter with Year</p>
                          <div className="form-group mb-3">
                            <Select
                              value={year}
                              onChange={(e) => {
                                const newSchedules =
                                  filterCohortsByMonthAndYear(
                                    allCohorts,
                                    month?.value ?? null,
                                    e?.value
                                  );
                                setYear(e);
                                setFilteredSchedules(newSchedules);
                              }}
                              options={years}
                              styles={Style}
                              placeholder="Year"
                            />
                          </div>
                        </Col>
                      </div>
                    )}

                    <div className="form-group date-list mb-3">
                      {filteredSchedules?.length > 0 ? (
                        filteredSchedules?.map((_sche) => {
                          const startDate = new Date(_sche?.start_date);
                          const endDate = new Date(_sche?.end_date);
                          const currentDate = new Date();
                          // const modifiedDate = addDays(endDate, 67);
                          const modifiedDate = addDays(endDate, 7);

                          const isEligible =
                            isAfter(currentDate, startDate) &&
                            (isBefore(currentDate, modifiedDate) ||
                              isSameDay(currentDate, modifiedDate));

                          return (
                            <div
                              className={`d-flex align-items-center justify-content-between weeks ml-2 mb-2 ${
                                isEligible ? "" : "disabled"
                              }`}
                              key={_sche?.id}
                            >
                              <p className="mr-2">
                                {dayjs(_sche?.start_date).format(
                                  "MMMM D, YYYY"
                                )}
                                {" - "}
                                {dayjs(_sche?.end_date).format("MMMM D, YYYY")}
                              </p>
                              <div className="me-4 cursor-pointer">
                                <input
                                  type="checkbox"
                                  className="cursor-pointer"
                                  checked={
                                    schedule?.id === _sche?.id ||
                                    isAfter(currentDate, modifiedDate)
                                      ? true
                                      : false
                                  }
                                  onChange={() => {
                                    schedule?.id === _sche?.id
                                      ? setSchedule(null)
                                      : setSchedule(_sche);
                                    setShow(false);

                                    let query = `page=1&page_size=100&attendance_schedule=${_sche?.id}&program=${selectedProgram?.value}`;
                                    setFilter(query);
                                    setSelected(true);
                                    // refetchFellows(false)
                                    refetchFellows();
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="d-flex justify-content-center align-items-center flex-column">
                          <p>No weekly schedules for the specified filter</p>
                          <button
                            className="btn btn-primary-outline"
                            onClick={() => loadOriginalSchedules()}
                          >
                            Reset
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                </ul>
              </div>
            </div>
          )}

          {isLoading && (
            <span
              className="spinner-border spinner-border-sm me-2 ms-2"
              role="status"
              aria-hidden="true"
            />
          )}
        </div>

        <button
          className="btn btn-outline-light text-start d-flex justify-content-between align-items-center report-btn"
          type="button"
          onClick={() => {
            navigate(Path.PROVIDER_ATTENDANCE_REPORT);
          }}
        >
          <i className="bi bi-sliders"></i>
          <span>View Report</span>
        </button>
      </div>

      {selectedProgram && selectedCohort && schedule && (
        <div className="row align-items-center g-3">
          <div className="col-md-12">
            <div className="d-flex justify-content-between align-items-center">
              <div className="search-box" style={{ width: "95%" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search for Fellows"
                  onChange={handleInputChange}
                  value={search}
                />
              </div>

              {searched ? (
                <button
                  className="btn btn-primary me-2 ms-2"
                  onClick={() => {
                    setSearch("");
                    setSearched(false);
                    setFilter(
                      `page=1&page_size=100&attendance_schedule=${schedule?.id}`
                    );
                  }}
                >
                  Clear
                </button>
              ) : (
                <button
                  className="btn btn-outline-light me-2 ms-2"
                  onClick={() => {
                    if (search?.length > 0) {
                      setFilter(
                        `page=1&attendance_schedule=${schedule?.id}&search=${search}`
                      );
                      setSearched(true);
                      // setClear(!clear);
                      // setFiltered(false);
                    }
                  }}
                >
                  <i className="bi bi-search"></i>
                </button>
              )}

              <button
                className="btn btn-outline-light"
                onClick={() => setShowFilter(true)}
              >
                <i className="bi bi-filter"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <FilterModal
        filterData={filterData}
        setShowFilter={setShowFilter}
        setFilter={setModalFilter}
        setFiltered={setFiltered}
      />
    </div>
  );
};

export default AttendanceHeader;
